import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// one-time migration of legacy storage keys (calenx_* -> spacecal_*)
try {
  ['token', 'saved_email', 'remember_me'].forEach((k) => {
    const old = localStorage.getItem(`calenx_${k}`);
    if (old !== null && localStorage.getItem(`spacecal_${k}`) === null) localStorage.setItem(`spacecal_${k}`, old);
    localStorage.removeItem(`calenx_${k}`);
  });
} catch (e) { /* storage unavailable */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
